module.exports = __webpack_public_path__ + "static/media/206-header4.fadb23ca.jpg";